import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'times',
  standalone: true,
})
export class TimesPipe implements PipeTransform {
  transform(value: number): any[] {
    return new Array(value);
  }
}
